module.exports = __webpack_public_path__ + "img/9788946060227.17699c28.jpg";